<template>
  <div class="container-fluid">
    <div class="row login-details">
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 center centered">
        <div class="login-whitebox">
          <form @submit.prevent="loginUser">
            <div class="login-input form-group col-sm-12 page_header">
              Login with your account details below:
            </div>
            <div class="login-input form-group col-sm-12">
              <label for="email">Email</label>
              <span class="required_astric">*</span>
              <input
                class="form-control"
                type="text"
                id="email"
                name="email"
                placeholder="E-mail Address"
                v-model="email"
              />
            </div>
            <div class="login-input form-group col-sm-12">
              <label for="password">Password</label>
              <span class="required_astric">*</span>
              <div class="password-flex">
                <input
                  class="form-control eye"
                  ref="inputTag"
                  type="password"
                  id="password"
                  name="password"
                  placeholder="Password"
                  v-model="password"
                />
                <img
                  v-if="showPassword"
                  src="/static/images/icons/eye.svg"
                  class="eye-icon"
                  @click="toggleEye"
                  alt="eye-icon"
                />
                <img
                  v-if="!showPassword"
                  src="/static/images/icons/eye_slash.svg"
                  class="eye-slash-icon"
                  @click="toggleEye"
                  alt="eye-icon"
                />
              </div>
            </div>
            <div class="col-sm-12 emergo-button">
              <button
                class="btn emergo-green-button custom-padding"
                :disabled="disableSubmit || disableFormSubmit"
                type="submit"
              >
                {{ LoginButton }}
              </button>
            </div>
            <div class="pt-5 pb-0">
              <router-link to="/forgot">Forgot your password?</router-link>
            </div>
            <div class="text-center">
              Don't have an account yet?
              <router-link to="/register">Sign Up</router-link>
            </div>
            <div class="text-center">
              <a href="https://rams-emergobyul.groovehq.com/help" target="_blank">FAQs</a>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment';
import { loginUser } from '../../apis/login';
import { getCookie } from '../../utils/common';
import { getUserData } from '../../apis/profile';

export default {
  data() {
    return {
      showPassword: true,
      email: '',
      password: '',
      selectedAccount: '',
      errorMessage: '',
      LoginButton: 'Log In',
      disableFormSubmit: false
    };
  },
  components: {},
  created() {
    if (this.$route.query) localStorage.setItem(`utm_codes`, JSON.stringify(this.$route.query));
    this.checkMessages();
  },
  computed: {
    disableSubmit() {
      if (this.email && this.password) {
        return false;
      }
      return true;
    }
  },
  methods: {
    checkMessages() {
      if (this.$route.params.successMessage) {
        this.$notify({
          clear: true,
          group: 'custom-notification'
        });
        this.$notify({
          type: 'success',
          title: 'Success',
          text: this.$route.params.successMessage,
          group: 'custom-notification'
        });
      }
      if (this.$route.params.errorMessage) {
        this.$notify({
          clear: true,
          group: 'custom-notification'
        });
        this.$notify({
          type: 'error',
          title: 'Error',
          text: this.$route.params.errorMessage,
          group: 'custom-notification'
        });
      }
    },
    toggleEye() {
      this.showPassword = !this.showPassword;
      if (!this.showPassword) {
        this.$refs.inputTag.type = 'text';
      } else {
        this.$refs.inputTag.type = 'password';
      }
    },
    getFormData() {
      return {
        email: this.email,
        password: this.password
      };
    },
    getRepCltFormData() {
      return {
        email: this.email,
        password: this.password,
        account_id: this.selectedAccount.account_id,
        role_id: this.selectedAccount.role_id,
        company_name: this.selectedAccount.company_name
      };
    },
    async loginUser() {
      if (getCookie('Authorization')) {
        this.redirectUrl();
        return;
      }
      const formData = this.getFormData();
      this.disableFormSubmit = true;
      this.LoginButton = 'Logging in...';
      const responseData = await loginUser(formData);
      if (!responseData) {
        this.LoginButton = 'Log In';
        this.disableFormSubmit = false;
      } else if (responseData && responseData.status === true) {
        localStorage.setItem('roleId', responseData.role_id);
        localStorage.setItem('userId', responseData.user_id);
        localStorage.setItem('accountId', responseData.account_id);
        await getUserData();
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'Login',
          UserID: responseData.user_id,
          CompanyID: JSON.parse(localStorage.getItem('userData')).company,
          DateOfLogin: moment().format('MM-DD-YYYY')
        });
        this.redirectUrl(responseData.role_id);
      } else if (responseData.status === 'invalid') {
        this.LoginButton = 'Log In';
        this.disableFormSubmit = false;
        this.$notify({
          clear: true,
          group: 'custom-notification'
        });
        this.$notify({
          type: 'error',
          title: 'Error',
          text: responseData.message,
          group: 'custom-notification'
        });
      }
    },
    redirectUrl(roleId) {
      const redirectUrl = getCookie('redirect_url');
      if (redirectUrl) {
        document.cookie = 'redirect_url=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
        window.location.href = redirectUrl;
      } else if (roleId === 11) this.$router.push('/layout/launchpad');
      else this.$router.push('/layout/dashboard');
    }
  }
};
</script>
<style scoped lang="scss">
// @import '../../../public/static/app/saas/variable';
.container-fluid {
  font-size: $font-16;
  line-height: 23px;
  color: $black-alpha;

  .login-whitebox {
    display: inline-block;
    padding: 0 10px;

    a {
      font-weight: $font-weight-600;
      font-size: $font-16;
      text-decoration: none;
      color: $messenger-blue;
      -webkit-transition: all 0.1s ease;
      -o-transition: all 0.1s ease;
      transition: all 0.1s ease;
      border-bottom: 0px solid $messenger-blue;
    }

    .page_header {
      font-family: 'Roboto';
      font-weight: 400;
      font-size: 18px;
      line-height: 21px;
      margin: 40px 0px 32px 0px;
    }

    .home-login-button,
    .home-login-button[disabled] {
      padding: 7px 30px;
    }
  }
}
#dlInput {
  max-width: 450px;
  margin: auto;
  padding-top: 10px;
  padding-bottom: 10px;
}
.modal_wrapper {
  padding: 20px 0;
  width: 100%;
}
.container-fluid {
  font-family: 'Roboto';
  font-size: 16px;
  line-height: 23px;
  color: rgba(0, 0, 0, 0.87);
}
.header_wrapper {
  border-bottom: 1px solid #ccc;
  padding: 0px;
  margin: 0 0 15px 0;
  margin-left: 0px;
  padding-left: 0px;
}
.footer_wrapper {
  border-top: 1px solid #ccc;
  margin-top: 15px;
}
.mt-15 {
  margin-top: 15px;
}
.login-whitebox a {
  font-weight: 600;
  font-size: 16px;
  text-decoration: none;
  color: #2f80ed;
  -webkit-transition: all 0.1s ease;
  -o-transition: all 0.1s ease;
  transition: all 0.1s ease;
  border-bottom: 0px solid #2f80ed;
  padding-bottom: 5px;
}
.login-whitebox {
  display: inline-block;
  margin-top: 60px;
  margin-bottom: 25px;
  padding: 0px 0px;
  background: #ffffff;
  border: 0.8px solid #bdbdbd;
  border-radius: 10px;
}
.close {
  opacity: 1;
  color: #aaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
  margin-right: 10px;
  margin-top: -5px;
}
.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}
select:focus {
  border: 1px solid #ccc !important;
}
.text-center {
  padding-top: 16px;
}
.alert-success {
  color: $north-texas-green;
}
#showErrorMsg {
  display: none;
}
.error {
  color: $light-danger;
}
.world-map {
  width: 100%;
}
.login-details {
  background-image: url(/static/images/logos/World_Map_Login.svg);
  background-repeat: no-repeat;
  background-size: 100%;
}
.login-input.form-group {
  text-align: left;
  margin-bottom: 40px;
  padding: 0px 32px;
}
.login-whitebox .emergo-green-button,
.login-whitebox .emergo-green-button[disabled] {
  padding: 7px 30px;
  width: 100%;
}
.emergo-button {
  padding: 0px 32px 32px 32px;
}

.login-whitebox .text-center:last-child {
  padding-bottom: 42px;
}
.form-group label {
  padding-right: 5px;
}
.form-control {
  margin-top: 2px;
}
.required_astric {
  color: #b00505;
}
.password-flex {
  display: flex;
}
.eye-icon,
.eye-slash-icon {
  margin-top: 14px;
}
@media screen and (max-width: 767px) {
  .login-details {
    background-repeat: initial;
  }
}
@media only screen and (max-width: 991px) {
  .login-details {
    background-size: unset;
  }
}
@media screen and (max-width: 640px) {
  .login-whitebox {
    min-width: 90vw;
  }
}
@media (min-width: 768px) and (max-width: 820px) {
  .login-details {
    min-height: 65vh;
  }
}
@media (min-width: 768px) and (max-width: 991px) {
  .login-details {
    background-size: unset;
  }
}
</style>
